/** i18n bootstrap for the Agents Assistant. Imported once, before React mounts. */

import { initI18n } from "@nab/shared";

import ar from "./locales/ar.json";
import en from "./locales/en.json";

// Employees at NAB branches work primarily in Arabic, so an employee with no stored preference
// and no browser hint gets Arabic here — unlike the back-office, whose default is English.
initI18n({ appResources: { ar, en }, defaultLanguage: "ar" });
